var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-overlay',{attrs:{"value":_vm.reportLoading,"absolute":"","opacity":_vm.opacity}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"36","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }